import React from 'react';
import {TextField} from '@betareader/design-system';
import {withTranslation} from 'react-i18next';

const platforms = [
  {
    key: 'goodreads',
    label: 'Goodreads',
    placeholder: 'https://www.goodreads.com/user/show/12345-your-name',
    errorKey: 'ValidGoodreadsUrl',
  },
  {
    key: 'instagram',
    label: 'Instagram',
    placeholder: 'https://www.instagram.com/your-username',
    errorKey: 'ValidInstagramUrl',
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    placeholder: 'https://www.tiktok.com/@your-username',
    errorKey: 'ValidTikTokUrl',
  },
];

export const SocialProfiles = ({socialProfiles = {}, onChange, t, errors = {}}) => (
  <div>
    <p>{t('SocialProfilesDescription')}</p>
    <div style={{display: 'grid', gap: 16}}>
      {platforms.map(({key, label, placeholder, errorKey}) => {
        const errorId = `social-profile-${key}-error`;
        return (
          <div key={key}>
            <TextField id={`social-profile-${key}`} label={label} type='url'
              placeholder={placeholder} value={socialProfiles[key] || ''}
              onChange={event => onChange({
                ...socialProfiles,
                [key]: event.target.value,
              })}
              aria-invalid={!!errors[key]}
              aria-describedby={errors[key] ? errorId : undefined} />
            {errors[key] && (
              <p id={errorId} role='alert' style={{color: 'var(--br-danger)'}}>
                {t(errorKey)}
              </p>
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default withTranslation()(SocialProfiles);
